import React from "react";
import moment from "moment";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import ActionBox from "./ActionBox";
import { statusColor, statusText } from "../../../../util";

export default ({ classes, event, ...rest }) => {
  return (
    <Box className={classes.detailContentBox}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          className={classes.buttonText}
          style={{ marginLeft: 0 }}
          noWrap
        >
          {event.title}
        </Typography>
        <CloseIcon className={classes.closeIcon} />
      </Box>

      <Box style={{ marginTop: 8, display: "flex", alignItems: "center" }}>
        <Typography
          className={classes.expandBoxText}
          style={{
            color: statusColor(event.status),
            borderRadius: 20,
            border: "1px solid",
            padding: "0 8px",
            borderColor: statusColor(event.status),
          }}
        >
          {statusText(event.status)}
        </Typography>
        <Box
          style={{
            width: 4,
            height: 4,
            background: "#DADADA",
            borderRadius: "50%",
            margin: 6,
          }}
        />
        <Typography
          className={classes.expandBoxText}
          style={{ fontWeight: 400, color: "rgba(51, 51, 51, 0.75)" }}
        >
          {moment(event.startAt).format("D MMM, YYYY")}
        </Typography>
      </Box>

      <ActionBox classes={classes} data={event} {...rest} />

      <Box style={{ marginTop: 16, flexGrow: 1, border: "1px solid #DADADA" }}>
        <img
          src={event.image?.fileUrl}
          alt="event thumbnail"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>
    </Box>
  );
};
